import type { SxProps, Theme } from "@mui/material";

/**
 * Shared sizing for the two voice buttons that sit inside the search pill.
 *
 * They have to be sized against the pill, which is 36px tall (26px on mobile).
 * Each button used to be 64x64 inside a 20px-padded wrapper - about 104px of
 * horizontal space apiece. One was already oversized; a second pushed the text
 * input sharply to the left.
 *
 * Shared rather than duplicated because the two sit side by side: if they ever
 * disagree about size the pair looks broken.
 */
export const voiceButtonSx: SxProps<Theme> = {
  width: { xs: 24, sm: 30 },
  height: { xs: 24, sm: 30 },
  // Keeps the pair from being squeezed when the input holds a long question.
  flexShrink: 0,
  mx: { xs: 0.25, sm: 0.5 },
  p: 0,
  backgroundColor: "transparent",
  "&:hover": { backgroundColor: "transparent" },
  "&.Mui-focusVisible": { backgroundColor: "transparent" },
};
